import { api } from "@";

import { searchValuesPayload } from "./helpers";

// Fetch a paginated list of abandoned Customers based Campaigns on search criteria
export const getCustomerCampaigns = (page = 1, pageSize = "", searchKey) => {
  return api.post(
    `/api/AdminCustomerSuggestedCampaigns/search`,
    searchValuesPayload({ searchKey, page, pageSize }),
  );
};
